import { on, ACTIONS } from '@/services/tabs';
import { RELOAD_USER } from '@/store/session/actionTypes';

export default (store) => {
  on('action', (action) => {
    switch (action.type) {
      case ACTIONS.RELOAD_USER:
        return store.dispatch(RELOAD_USER);
      default:
        // do nothing
        return null;
    }
  });
};
